module.exports = __webpack_public_path__ + "img/1717384058279-WhatsApp Image 2024-06-03 at 08.48.41.jpeg.f5365ecf.webp";